// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-loader{position:absolute;top:0;left:0;width:100%;height:100%;z-index:10;background:#fff}", ""]);
// Exports
module.exports = exports;
